import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { hostsApi } from '../../api/lib/hosts';

import { hostsKeys } from '@/features/hosts/api/query-keys/hosts';

export const useAssignInviteToParkingForHost = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: (hostId: number) => hostsApi.assignInviteToParkingForHost(hostId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: hostsKeys.all,
      });

      toast.success(t('common:popup.success'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
